import React from "react";
import styles from "./animation.module.css";

const Loading = () => {
    return (
        <div className={styles["jumping-balls-container"]}>
            <div className={styles["jumping-balls"]}>
                <div className={`${styles.ball} ${styles.red}`}></div>
                <div className={`${styles.ball} ${styles.blue}`}></div>
                <div className={`${styles.ball} ${styles.green}`}></div>
                <div className={`${styles.ball} ${styles.yellow}`}></div>
            </div>
        </div>
    );
};

export default Loading;